import { ElementWrapper } from "../../../components/ElementWrapper";
import { IElement } from "../../../models/Element";
import { MarginType } from "../../utils";
import { MarginBottomElement } from "./MarginBottomElement";

type MarginBottomElementFCProps = {
	index: number;
	data: MarginBottomElement;
	updateData: (element: IElement, index: number) => void;
};

export const MarginBottomElementFC = ({
	index,
	data,
	updateData,
}: MarginBottomElementFCProps) => {
	const update = (fieldsToUpdate: Partial<MarginBottomElement>) => {
		const updatedData = { ...data, ...fieldsToUpdate };
		updateData(updatedData, index);
	};

	return (
		<ElementWrapper elementIndex={index}>
			<section className={`${data.name} w-100 my-10`}>
				<select
					className="form-select form-select-lg form-select-solid text-capitalize"
					data-control="select2"
					data-placeholder="Select Status..."
					value={data.unit}
					onChange={(e) =>
						update({
							unit: e.target.value,
						})
					}
				>
					<option
						value={MarginType.MARGIN_10}
					>{`Margin Bottom Element = ${MarginType.MARGIN_10}`}</option>
					<option
						value={MarginType.MARGIN_15}
					>{`Margin Bottom Element = ${MarginType.MARGIN_15}`}</option>
					<option
						value={MarginType.MARGIN_20}
					>{`Margin Bottom Element = ${MarginType.MARGIN_20}`}</option>
					<option
						value={MarginType.MARGIN_25}
					>{`Margin Bottom Element = ${MarginType.MARGIN_25}`}</option>
					<option
						value={MarginType.MARGIN_30}
					>{`Margin Bottom Element = ${MarginType.MARGIN_30}`}</option>
					<option
						value={MarginType.MARGIN_35}
					>{`Margin Bottom Element = ${MarginType.MARGIN_35}`}</option>
					<option
						value={MarginType.MARGIN_40}
					>{`Margin Bottom Element = ${MarginType.MARGIN_40}`}</option>
				</select>
			</section>
		</ElementWrapper>
	);
};
